"use strict";

$(document).ready(function () {
  $('button[data-feedback-answer="no"]').click(function (event) {
    $('#feedback-question').addClass("is-hidden");
    $('#feedback-more-info').removeClass("is-hidden");
  });
  $('button[data-feedback-answer="yes"]').click(function (event) {
    $('#feedback-question').addClass("is-hidden");
    $('#feedback-thank-you').removeClass("is-hidden");
  });
  $('#feedback-form').submit(function (event) {
    event.preventDefault();
    $('#feedback-more-info').addClass("is-hidden");
    $('#feedback-thank-you').removeClass("is-hidden");
  });
});